var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property_indicators, is_mobile, leadSubmitted, isLeadFormSuppressed, placeholder, shareModalTarget, virtualTourLink, realTip, propertyStatus, pageType, isGraphicalUplift, isGraphicalEnhance, hasSuppressLeadForm  } = options; 
__p+='\n';
 let indicatorClass = isGraphicalUplift || isGraphicalEnhance ? 'graphical-indicators' : 'qv-property-indicators'; 
__p+='\n\n<div class="'+
((__t=( indicatorClass ))==null?'':__t)+
' clearfix">\n  ';
 if (placeholder) { 
__p+='\n    <div class="loading"></div>\n  ';
 } 
__p+='\n  ';
 if(property_indicators.length) { 
__p+='\n    ';
 if (isGraphicalUplift || isGraphicalEnhance) { 
__p+='\n      <ul class="row indicators">\n        ';
 property_indicators.forEach((indicator) => { 
__p+='\n          ';
 const { value, valueBefore, valueAfter, icon, key } = indicator || {}; 
__p+='\n          ';
 const indicatorValue = [valueBefore, value, valueAfter].filter(Boolean).join('\n'); 
__p+='\n          ';
 const listDescriptionClass = indicator.key === 'Property Type' ? 'list-description-pro-type' : '' 
__p+='\n          <li class="col-qv-xs-6 col-qv-sm-4 col-qv-md-4 col-qv-lg-2 list-indicator">\n            <div class="list-description '+
((__t=( listDescriptionClass ))==null?'':__t)+
'"\n                ';
 if((indicator.key === 'Style' || indicator.key === 'Property Type' || indicator.key === 'Heating') || indicator.key === 'Cooling' ) { 
__p+=' data-toggle="tooltip" title="'+
((__t=( value.split(',').join(', ') ))==null?'':__t)+
'" data-placement="top"';
 } 
__p+='>\n              <div class="indicator-icon '+
((__t=( indicator.icon ))==null?'':__t)+
' col-md-3"></div>\n              ';
 if(indicatorValue.includes("Not")){   
__p+='\n              <div class="indicator-value col-md-9 ellipsis">'+
((__t=( indicatorValue.replace("Not Available","").trim() ))==null?'':__t)+
'</div>\n              <a href="javascript:void(0);" class="ask-agent">Ask agent</a>\n              ';
} else { 
__p+='\n                <div class="indicator-value col-md-9 ellipsis">'+
((__t=( indicatorValue ))==null?'':__t)+
'</div>\n                ';
} 
__p+='\n            </div>\n          </li>\n        ';
 }) 
__p+='\n      </ul>\n    ';
 } else { 
__p+='\n      <ul class="row indicators">\n          ';
 property_indicators.forEach((indicator) => { 
__p+='\n            <li class="col-qv-xs-6 col-qv-md-4 indicator">\n              <div class="ellipsis text-right"\n                ';
 if(indicator.key == 'Property Type' || indicator.key == 'Style' ) { 
__p+=' data-toggle="tooltip" title="'+
((__t=( indicator.value ))==null?'':__t)+
'" data-placement="top"';
 } 
__p+='>\n                <span class="key">'+
((__t=( indicator.key ))==null?'':__t)+
'</span>\n                ';
 if (indicator.key === 'Builder') { 
__p+='\n                  <a href="'+
((__t=( indicator.value.href ))==null?'':__t)+
'"\n                    target="_blank"\n                    rel="nofollow noopener noreferrer"\n                    data-omtag="for_sale:ldp:property_indicators:broker_site"\n                    class="builder-href value">\n                    '+
((__t=( indicator.value.name ))==null?'':__t)+
'\n                  </a>\n                ';
 } else { 
__p+='\n                  <span class="font-semibold value ellipsis">'+
((__t=( indicator.value ))==null?'':__t)+
'</span>\n                ';
 } 
__p+='\n              </div>\n            </li>\n          ';
 }) 
__p+='\n      </ul>\n    ';
 } 
__p+='\n  ';
 } 
__p+='\n</div>\n    ';
 if (!$.Device.isMobile(navigator.userAgent)) { 
__p+='\n      '+
((__t=( JST['quick_view/templates/realtip_section']({
        realTip
      }) ))==null?'':__t)+
'\n    ';
 } 
__p+='\n\n';
 if (!leadSubmitted && !isLeadFormSuppressed) { 
__p+='\n    ';
 if (hasSuppressLeadForm) { 
__p+='\n      <div class="qv-property-indicators-btn margin-top-lg margin-bottom-lg text-center">\n        <a href="javascript:void(0)" data-title="Ask a question" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':property-indicators:contact_agent" class="js-qv-contact-agent btn btn-primary margin-left-lg round-cta" data-placeholder="Ask a question">\n          Ask a question\n        </a>\n        <a href="javascript:void(0)" class="js-hide-ajax-fail btn btn-default margin-left-lg round-cta display-btn" data-toggle="modal" data-target="'+
((__t=( shareModalTarget ))==null?'':__t)+
'" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':sticky-top:share">\n          <span>Share this home</span>\n        </a>\n      </div>\n    ';
 } else { 
__p+='\n      <div class="qv-property-indicators-btn margin-top-lg margin-bottom-lg">\n        <a href="javascript:void(0)" class="js-hide-ajax-fail btn btn-default margin-left-lg round-cta" data-toggle="modal" data-target="'+
((__t=( shareModalTarget ))==null?'':__t)+
'" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':sticky-top:share">\n          <span>Share this home</span>\n        </a>\n      </div>\n    ';
 } 
__p+='\n';
 } 
__p+='\n\n<div id="div-gpt-ad-TXTLDP3" class="ad-quick-view-preload property-badge-ads"></div>\n\n';
 if (virtualTourLink){ 
__p+='\n  <div class="font-semibold qv-mobile-virtualtour-section visible-xxs-block">\n    View <a href="'+
((__t=( virtualTourLink ))==null?'':__t)+
'" target="_blank" id="hero-view-tour" data-omtag="ldp:photogallery:virtual-tour">Virtual Tour</a> for this property\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-property-indicators.jst.ejs